import { createFileRoute } from "@tanstack/react-router";
import { requireDashboardOwner } from "@/lib/auth-guard";

export const Route = createFileRoute("/dashboard/settings")({
  beforeLoad: requireDashboardOwner,
});
